// eslint-disable-next-line no-restricted-imports
import MockStudent from "../api/mocks/getStudentUserStudent.json";
import type { RenderedClassForStudent } from "../api/models/students";
import type { StudentResponse } from "../api/studentUser";
import { mocksResponse } from "../utils/env";
import { UserManager } from "./UserManager";

export class StudentManager {
  private static _instance: StudentManager = new StudentManager();
  static get instance(): StudentManager {
    return this._instance;
  }

  private _classrooms: RenderedClassForStudent[] | undefined;

  async syncStudents(dataProvider: () => Promise<RenderedClassForStudent[]>) {
    if (!UserManager.instance.userId) {
      throw Error("Error syncing students for undefined user.");
    }
    if (mocksResponse()) {
      // return mocked reponse to avoid CORS errors in dev
      this._classrooms = (MockStudent._items[0] as StudentResponse).classes;
      return;
    }
    const classes = await dataProvider();
    this._classrooms = classes;
  }

  get classes(): RenderedClassForStudent[] {
    return this._classrooms ?? [];
  }
  set classes(classes: RenderedClassForStudent[]) {
    this._classrooms = classes;
  }

  get sortedClasses(): RenderedClassForStudent[] {
    return this.classes.sort((a, b) => b._id.localeCompare(a._id));
  }
}
